import { getAsyncProps } from '@builder.io/utils';
import { VimeoBuilderItem } from '@/components/builder/VimeoGallery/VimeoGallery.types';

export const getVimeoCarouselData = async (videoCarouselObj: any) => {
  // build Array of Vimeo video IDs
  const vimeoVideoIds: number[] = [];

  // loop through videoCarouselObj passed from getStaticProps in [[...slug]].tsx
  videoCarouselObj?.forEach((videoItem: VimeoBuilderItem) => {
    const videoId = Number(videoItem.videoId);
    if (!isNaN(videoId)) {
      vimeoVideoIds.push(videoId);
    }
  });

  // hit vimeo oembed API to get vimeo title, image
  const response = Promise.all(
    vimeoVideoIds.map(async videoId => {
      const vimeoData = await fetch(
        `https://vimeo.com/api/oembed.json?url=https://player.vimeo.com/video/${videoId}&width=1280&height=720`
      );
      return await vimeoData.json();
    })
  );
  const formattedVimeoData = (await response).map(data => ({
    video_id: data.video_id,
    title: data.title,
    thumbnail_url: data.thumbnail_url,
  }));
  return formattedVimeoData;
};

export const getSingleVimeoData = async (videoId: number) => {
  const response = await fetch(
    `https://vimeo.com/api/oembed.json?url=https://player.vimeo.com/video/${videoId}&width=640`
  ).then(res => res.json());

  const formattedVimeoData = (({ video_id, title, thumbnail_url }) => ({
    video_id,
    title,
    thumbnail_url,
  }))(response);

  return formattedVimeoData;
};

export const getBuilderVimeoStaticProps = async (content: any) => {
  await getAsyncProps(content, {
    async VimeoGallery(props) {
      const videoIds = props.videos;
      // Assuming getVimeoCarouselData is defined elsewhere
      const vimeoDataResponse = await getVimeoCarouselData(videoIds);

      props.vimeoResponse = vimeoDataResponse;

      return props;
    },

    async CampaignVimeoModal(props) {
      const videoIds = props.videos;
      // Assuming getVimeoCarouselData is defined elsewhere
      const vimeoDataResponse = await getVimeoCarouselData(videoIds);

      props.vimeoResponse = vimeoDataResponse;

      // Assuming getSingleVimeoData is defined elsewhere
      const backgroundVideoResponse = await getSingleVimeoData(
        props.backgroundVideoId
      );
      props.backgroundThumbnailUrl = backgroundVideoResponse.thumbnail_url;

      return props;
    },
  });

  return content;
};
